import { CommonModule } from '@angular/common';
import { Component,Input,ViewChild } from '@angular/core';
import { MatLegacyTooltip as MatTooltip,MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-hint-icon',
    standalone: true,
    imports: [CommonModule, FontAwesomeModule, MatTooltipModule],
    templateUrl: './hint-icon.component.html',
    styleUrls: ['./hint-icon.component.scss'],
})
export class HintIconComponent {
    @Input() hint: string;
    @Input() multiline: boolean = false;
    @ViewChild(MatTooltip) tooltip: MatTooltip;
    constructor() {}
    onTooltipClick() {
        this.tooltip?.show();
    }
}
